import { Map } from "immutable"
import {
    getList,
    getItem,
    putItem,
    postItem
} from "./utils/entity-network-requests"

const entityName = "community"

export const getCommunityList = (token, parameters) =>
    getList(entityName, parameters, token)
export const getCommunityItem = (token, id) => getItem(entityName, id, token)
export const putCommunityItem = (token, id, community) =>
    putItem(entityName, id, community, token)
export const postCommunityItem = (token, community) =>
    postItem(entityName, community, token)
export const getCommunityPossibleLabels = (token, search) =>
    getItem(entityName, "possible_labels", token, Map({ search }))
export const getCommunityPossibleSystemLabels = (token, search) =>
    getItem(entityName, "possible_system_labels", token, Map({ search }))
